/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldWrapper } from "../FieldWrapper";

import "./FieldResponsiveButton.scss";
import { FieldActionButton } from "../FieldActionButton";

export interface IFieldResponsiveButtonProps {
	readOnly?: boolean;
	className?: string;
	disabled?: boolean;
	onClick?: React.MouseEventHandler;
	selected?: boolean;
	tooltip?: string;
	iconName?: string;
}

export const FieldResponsiveButton: React.FC<IFieldResponsiveButtonProps> = ({
	readOnly,
	disabled,
	className,
	onClick,
	selected,
	iconName: iconNameProp,
	tooltip
}) => {
	const baseClass = BEM("edt-field-responsive-button");

	const iconName = selected || !iconNameProp ? "mdi/responsive" : iconNameProp;

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldWrapper type="responsive-button">
			<FieldActionButton
				iconName={iconName}
				className={baseClass.toClassName()}
				onClick={onClick}
				disabled={disabled || readOnly}
				selected={selected}
				tooltip={tooltip}
			/>
		</FieldWrapper>
	);
};

FieldResponsiveButton.defaultProps = {
	iconName: "mdi/responsive"
};
